import Swiper from "swiper";

export default {

    changeBtn(item,index) {
        this.download_img = this.downloadInfo[item.key];
    },

    wechatLogin(code) {
        this.$post('api.php/Index/pcwxlogin',{
            code: code
        }).then(res => {
            if(res.status === 1) {
                this.$message.success(res.info);
                localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(res.data || {})));
                this.$store.commit('setUser',res.data || {})
                this.$parent.$children[0].userinfo = res.data || {}
                this.$parent.$children[0].checkLogin();
                this.$parent.$children[0].closeMask();
            }
        })
    },

    initSwiper() {
        let that = this;

        this.timer = setTimeout(() => {
            new Swiper('.swiper-container-big', {
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                loop: true,
                loopAdditionalSlides: 3,
                slidesPerView: "auto",
                centeredSlides: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    init: function(swiper){
                        this.emit('slideChange');//在初始化时触发一次transitionEnd事件，需要先设置transitionEnd

                    },
                    slideChange() {
                        that.selected = this.realIndex;

                        let index = this.realIndex;

                        if(index === 0 && that.indexNum === 0) {
                            return false;
                        }

                        for(let i=0,count=this.slides.length;i<count;i++){

                            let mark = this.slides.eq(i).children('.mask_k')[0];

                            if (mark) {
                                mark.parentNode.removeChild(mark);
                            }

                            let title = this.slides.eq(i).children('.banner-title')[0];

                            // if(title){
                            //     title.parentNode.removeClass('block');
                            // }

                            if(i !== this.activeIndex) {
                                this.slides.eq(i).append('<div class="mask_k"></div>');
                                title.classList.remove('block')
                                title.classList.add('none')
                            }else {
                                title.classList.remove('none')
                                title.classList.add('block')
                            }
                        }

                        that.indexNum = index;

                        // if(index === 0) {
                        //     that.indexNum = 0;
                        // }else if(index === 2){
                        //     that.indexNum = 2;
                        // }else {
                        //     that.indexNum = 1;
                        // }

                        // console.log(that.selected,this.realIndex)



                    }
                }
            });

            new Swiper('.swiper-container-small',{
                autoplay: {
                    delay: 3000
                },
                // loop: true,
                on: {
                    slideChange() {
                        that.selected_small = this.realIndex;
                    },

                }
            });
        },500)
    },

    openBigPhoto(cIndex,item) {
        this.is_big = true;
        this.photo = item.photo;
        this.initial_index = cIndex;
    },

    getDownloadInfo() {
        this.$post('api.php/Home/down').then(res => {
            if(res.status === 1) {
                this.downloadInfo = res.data || {};
                this.download_img = res.data.android || '';
                this.downloadList.map(item => {
                    item.image = res.data[item.key]
                })
            }
        })
    },

    qqLogin(code) {
        this.$post('api.php/Index/qLogin',{
            code: code
        }).then(res => {
            if(res.status === 1) {
                this.$message.success(res.info);
                localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(res.data || {})));
                this.$store.commit('setUser',res.data || {})
                this.$parent.$children[0].userinfo = res.data || {}
                this.$parent.$children[0].checkLogin();
                this.$parent.$children[0].closeMask();
            }else {
                this.$message.error(res.info);
            }
        })
    },

    getIndexInfo() {
        if(!this.showMore) {
            this.$message.info('没有更多了！');
            return;
        }
        const loading = this.$loading({
            text: '加载中...'
        })
        this.$post('api.php/Home/homePageInfo',{
            p: this.p
        }).then(res => {
            if(res.status == 1) {
                this.indexInfo = res.data || {};
                this.activity = res.data.activity || [];
                this.top_banner = res.data.top_banner || [];
                this.bottom_banner = res.data.bottom_banner || [];
                let star = res.data.article_star || [];
                let arr = res.data.headline.list || [];
                arr.map(item => {
                    if(item.photo.length > 6) {
                        item.photo = item.photo.slice(0,6);
                    }
                })
                if(arr.length < 6) {
                    this.showMore = false;
                }else {
                    this.showMore = true;
                }
                this.headline = this.headline.concat(arr);
                if(this.headline.length === res.data.headline.count) {
                    this.showMore = false;
                }
                this.hot_star = this.hot_star.concat(star);
                this.initSwiper();
            }
        }).finally(() => {
            loading.close();
        })
    },

    openTopic() {
        window.open(this._link + 'topic/detail?id=' + this.indexInfo.hot_topic.id)
        // this.$router.push({
        //     name: 'topic-detail',
        //     query: {
        //         id: this.indexInfo.hot_topic.id
        //         // data: this.$Encrypt(JSON.stringify(this.indexInfo.hot_topic))
        //     }
        // })
    },

    getMore() {
        if(this.showMore) {
            this.p++;
            this.getIndexInfo();
        }
    },

    openPage(item) {
        // this.$router.push({
        //     name: 'news-detail',
        //     query: {
        //         id: item.id
        //     }
        // })
        window.open(this._link + 'news/detail?id=' + item.id)
    },

    nextActive() {
        this.$post('api.php/Home/nextActivity').then(res => {
            if (res.status == 1) {
                this.activity = res.data || [];
            }
        })
    },

    openActiveDetail(item) {
        // console.log(item);
        // this.$router.push({
        //     name: 'active-detail',
        //     query: {
        //         id: item.id,
        //         type: item.type
        //     }
        // })
        window.open(this._link + 'active/detail?id=' + item.id + '&type=' + item.type)
    },

    openLinkPage(item) {
        if(item.type === 1) {
            window.open(item.href)
        }else if(item.type === 2) {
            // this.$router.push({
            //     name: 'news-detail',
            //     query: {
            //         id: item.link_id
            //     }
            // })
            window.open(this._link + 'news/detail?id=' + item.link_id)
        }else if(item.type === 3) {
            item.type = 2;
            window.open(this._link + 'active/detail?id=' + item.link_id + '&type=' + item.type)
            // this.$router.push({
            //     name: 'active-detail',
            //     query: {
            //         type: item.type,
            //         id: item.link_id
            //     }
            // })
        }else if(item.type === 5) {
            item.type = 1;
            window.open(this._link + 'active/detail?id=' + item.link_id + '&type=' + item.type)
            // this.$router.push({
            //     name: 'active-detail',
            //     query: {
            //         type: item.type,
            //         id: item.link_id
            //         // data: this.$Encrypt(JSON.stringify(item))
            //     }
            // })
        }else {
            window.open(this._link + 'topic/detail?id=' + item.link_id)
            // this.$router.push({
            //     name: 'topic-detail',
            //     query: {
            //         id: item.link_id
            //         // data: this.$Encrypt(JSON.stringify(item))
            //     }
            // })
        }
    },

    // 参与活动
    openActive(item) {
        window.open(this._link + 'active/detail?id=' + item.id + '&type=' + item.type)
        // this.$router.push({
        //     name: 'active-detail',
        //     query: {
        //         type: item.type,
        //         id: item.id
        //         // data: this.$Encrypt(JSON.stringify(item))
        //     }
        // })
    },

    openStar(item) {
        window.open(this._link + 'news/detail?id=' + item.id)
        // this.$router.push({
        //     name: 'news-detail',
        //     query: {
        //         data: this.$Encrypt(JSON.stringify(item))
        //     }
        // })
    }

}
